import Vue from 'vue'
import App from './app.vue'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import VueGtag from 'vue-gtag'
import Vuelidate from 'vuelidate'
import datePlugin from './plugins/datePlugin'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import Button from 'element-ui/lib/button'
import Menu from 'element-ui/lib/menu'
import Submenu from 'element-ui/lib/submenu'
import MenuItem from 'element-ui/lib/menu-item'
import MenuItemGroup from 'element-ui/lib/menu-item-group'
import FormItem from 'element-ui/lib/form-item'
import Form from 'element-ui/lib/form'
import Input from 'element-ui/lib/input'
import InputNumber from 'element-ui/lib/input-number'
import Row from 'element-ui/lib/row'
import Col from 'element-ui/lib/col'
import Container from 'element-ui/lib/container'
import Card from 'element-ui/lib/card'
import ColorPicker from 'element-ui/lib/color-picker'
import Header from 'element-ui/lib/header'
import Aside from 'element-ui/lib/aside'
import Main from 'element-ui/lib/main'
import Footer from 'element-ui/lib/footer'
import Checkbox from 'element-ui/lib/checkbox'
import CheckboxGroup from 'element-ui/lib/checkbox-group'
import Select from 'element-ui/lib/select'
import Option from 'element-ui/lib/option'
import Slider from 'element-ui/lib/slider'
import Rate from 'element-ui/lib/rate'
import Tabs from 'element-ui/lib/tabs'
import TabPane from 'element-ui/lib/tab-pane'
import ButtonGroup from 'element-ui/lib/button-group'
import Dialog from 'element-ui/lib/dialog'
import Upload from 'element-ui/lib/upload'
import Radio from 'element-ui/lib/radio'
import RadioBtn from 'element-ui/lib/radio-button'
import RadioGroup from 'element-ui/lib/radio-group'
import Table from 'element-ui/lib/table'
import TableColumn from 'element-ui/lib/table-column'
import Switch from 'element-ui/lib/switch'
import DatePicker from 'element-ui/lib/date-picker'
import TimePicker from 'element-ui/lib/time-picker'
import Tag from 'element-ui/lib/tag'
import Popover from 'element-ui/lib/popover'
import Dropdown from 'element-ui/lib/dropdown'
import DropdownMenu from 'element-ui/lib/dropdown-menu'
import DropdownItem from 'element-ui/lib/dropdown-item'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import ToolTip from 'element-ui/lib/tooltip'
import Badge from 'element-ui/lib/badge'
import Drawer from 'element-ui/lib/drawer'
import Pagination from 'element-ui/lib/pagination'

const isProd = process.env.NODE_ENV === 'production'
// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = isProd

Vue.use(datePlugin);
Vue.use(
  VueGtag,
  {
    config: { id: 'UA-126943379-1' },
    enabled: isProd,
  },
  router
)

// configure language
locale.use(lang)
// import components
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(ColorPicker)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(Slider)
Vue.use(Rate)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(RadioBtn)
Vue.use(RadioGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Tag)
Vue.use(Popover)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(ToolTip)
Vue.use(Badge)
Vue.use(Drawer)
Vue.use(Pagination)

// Adds Message globally so it can be used anywhere by calling 'this.$message'
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox

// Widget Specific START
Vue.prototype.$eventBus = new Vue() // used ONLY for communication between widget components
Vue.use(Vuelidate)
// Widget Specific END

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store: store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
